<template>
  <div class="credit-exhausted-notice mb-3">
    <v-card variant="tonal" color="primary" class="pa-4">
      <div class="d-flex align-start ga-3">
        <v-icon color="primary" class="mt-1">mdi-credit-card-off-outline</v-icon>
        <div class="flex-grow-1">
          <div class="text-body-2 mb-3">
            {{ t('credits.messageNotSent') }}
          </div>
          <v-btn color="primary" size="small" variant="flat" @click="dialog = true">
            {{ t('credits.contactUs') }}
          </v-btn>
        </div>
      </div>
    </v-card>

    <v-dialog v-model="dialog" max-width="420">
      <v-card class="pa-4">
        <div class="d-flex align-center mb-3">
          <div class="text-subtitle-1 font-weight-medium flex-grow-1">{{ t('sales.contactSales') }}</div>
          <v-btn icon="mdi-close" size="small" variant="text" :aria-label="t('common.close')" @click="dialog = false" />
        </div>
        <ContactSalesForm reason="exhausted" @submitted="onSubmitted" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { useI18n } from '../../composables/useI18n.js'
const { t } = useI18n()
import { ref } from 'vue'
import ContactSalesForm from '../sales/ContactSalesForm.vue'

const dialog = ref(false)

function onSubmitted() {
  // Leave the dialog open briefly so the user sees the success copy; they can
  // dismiss it themselves.
}
</script>
